import { render, staticRenderFns } from "./ministerIncidents.vue?vue&type=template&id=463ea9f0&scoped=true&"
import script from "./ministerIncidents.vue?vue&type=script&lang=js&"
export * from "./ministerIncidents.vue?vue&type=script&lang=js&"
import style0 from "./ministerIncidents.vue?vue&type=style&index=0&id=463ea9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ea9f0",
  null
  
)

export default component.exports